import {createTheme} from "@mui/material/styles";
import {alpha} from "@mui/material/styles";

export const createKioskTheme = (primary = "#1C2D42") => createTheme({
  palette: {
    primary: {main: primary},
    background: {default: "#F7F1E8", paper: "#FFFDF9"},
    text: {primary: "#2B211C", secondary: "#74675F"},
  },
  shape: {borderRadius: 8},
  typography: {
    fontFamily: '"Noto Sans TC", "PingFang TC", system-ui, sans-serif',
    button: {fontWeight: 900, textTransform: "none", fontSize: 18},
  },
  components: {
    MuiButton: {styleOverrides: {root: {minHeight: 52, borderRadius: 10}}},
    MuiDialog: {styleOverrides: {paper: {borderRadius: 14}}},
    MuiCssBaseline: {styleOverrides: `
      @keyframes kioskPulse {
        0% { box-shadow: 0 0 0 0 ${alpha(primary, .45)}; }
        70% { box-shadow: 0 0 0 16px ${alpha(primary, 0)}; }
        100% { box-shadow: 0 0 0 0 ${alpha(primary, 0)}; }
      }
      @keyframes kioskSlideUp {
        from { transform: translateY(100%); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
      @keyframes kioskPop {
        0% { transform: scale(1); }
        45% { transform: scale(1.12); }
        100% { transform: scale(1); }
      }
      @keyframes kioskArrow {
        0%, 100% { transform: translateX(0); }
        50% { transform: translateX(6px); }
      }
    `},
  },
});
